import { ca } from '@cian/analytics';

import { type IPromo } from '../types/promos';

import { getProductsData } from './getProductsData';

export function trackClickPromoBlock(promo: IPromo): void {
  const { promoType, uniquePromoId: promoCianMortgage } = promo;

  ca('eventSite', {
    action: 'click_block',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData({ promoCianMortgage })],
  });
}
